import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    margin-bottom: 10px;
  }
`
